import React, { useState } from 'react';

export default function Image(props) {
  const [error, setError] = useState(false);

  if (error) {
    return null;
  }

  const onError = () => {
    setError(true);
  };

  return (
    <>
      {React.Children.map(props.children, child => {
        if (child.props.src) {
          return <>{React.cloneElement(child, { onError })}</>;
        }
        return <>{child}</>;
      })}
    </>
  );
}
